import React from 'react';

interface TeamToggleProps {
  selectedTeam: 'home' | 'away';
  onSelectTeam: (team: 'home' | 'away') => void;
  homeTeamName?: string;
  awayTeamName?: string;
  homeCount: number;
  awayCount: number;
}

const TeamToggle: React.FC<TeamToggleProps> = ({
  selectedTeam,
  onSelectTeam,
  homeTeamName,
  awayTeamName,
  homeCount,
  awayCount,
}) => {
  return (
    <div className="flex gap-2 mb-4">
      <button
        onClick={() => onSelectTeam('home')}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
          selectedTeam === 'home'
            ? 'bg-blue-600 text-white'
            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700'
        }`}
      >
        {homeTeamName || 'Home'} ({homeCount})
      </button>
      <button
        onClick={() => onSelectTeam('away')}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
          selectedTeam === 'away'
            ? 'bg-blue-600 text-white'
            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700'
        }`}
      >
        {awayTeamName || 'Away'} ({awayCount})
      </button>
    </div>
  );
};

export default TeamToggle;
